<template>
    <v-card-text>
        <v-row v-if="loading">
            <v-col cols="12" md="7">
                <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
            </v-col>
        </v-row>
        <div v-if="!loading" style="overflow: auto; border-left: thin solid rgba(255, 255, 255, 0.18) !important;">
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="20"
                class="table__lined">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template v-slot:header="headerProps">
                    <thead>
                    <tr>
                        <th></th>
                        <th colspan="6" class="text-center">Входящие</th>
                        <th colspan="3" class="text-center">Исходящие</th>
                        <th></th>
                    </tr>
                    </thead>
                </template>
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.operatorId">
                        <td>{{ item.operatorName }}</td>
                        <td>{{ item.incomingTotal }}</td>
                        <td>{{ item.incomingAnswered }}</td>
                        <td>{{ item.incomingMissed }}</td>
                        <td>
                            <span :class="getMissedColor(item.missedPercent)">
                                {{ Math.round(item.missedPercent) }}%
                            </span>
                        </td>
                        <td>{{ formatSeconds(item.avgAnswerSeconds) }}</td>
                        <td>{{ formatSeconds(item.avgTalkSecondsIncoming) }}</td>
                        <td>{{ item.outgoingTotal }}</td>
                        <td>{{ item.outgoingAnswered }}</td>
                        <td>{{ formatSeconds(item.avgTalkSecondsOutgoing) }}</td>
                        <td>{{ formatSeconds(item.totalTalkSecondsAll) }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </div>
    </v-card-text>
</template>

<script>
import ReportService from "@/_services/ReportService";
import {reportHelper} from "@/_helpers/report/reportHelper";

export default {
    name: 'ReportCallStats',
    props: {
        filter: Object,
    },
    data: function () {
        return {
            loading: false,
            items: [],
            headers: [
                {text: 'Оператор', value: 'operatorName'},
                {text: 'Всего', value: 'incomingTotal'},
                {text: 'Принято', value: 'incomingAnswered'},
                {text: 'Пропущено', value: 'incomingMissed'},
                {text: '% пропущенных', value: 'missedPercent'},
                {text: 'Среднее время дозвона', value: 'avgAnswerSeconds'},
                {text: 'Среднее время разговора', value: 'avgTalkSecondsIncoming'},
                {text: 'Всего', value: 'outgoingTotal'},
                {text: 'Отвечено клиентом', value: 'outgoingAnswered'},
                {text: 'Среднее время разговора', value: 'avgTalkSecondsOutgoing'},
                {text: 'Суммарное время разговоров', value: 'totalTalkSecondsAll'},
            ]
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            ReportService.getCallStatsReport({dates: this.filter?.request?.createdAtDates}).then(report => {
                this.items = report.items;
                this.loading = false;
            });
        },
        getMissedColor(missedPercent) {
            return reportHelper.getStatColor(missedPercent, {
                colors: {
                    green: [0, 19.99],
                    yellow: [20, 39.99],
                    red: [40, 100]
                }
            });
        },
        formatSeconds(seconds) {
            if (seconds === null || seconds === undefined) {
                return '—';
            }
            const rounded = Math.round(seconds);
            const minutes = Math.floor(rounded / 60);
            const remainder = rounded % 60;
            return minutes > 0 ? `${minutes} мин ${remainder} сек` : `${remainder} сек`;
        }
    },
    created() {
        this.fetch();
    }
};
</script>
